export default __webpack_public_path__ + "static/media/DianaLovelace.aa6d957f.png";